import React from "react";

export const Card: React.FC<{
  title: string;
  value: string;
  icon: string;
  subtitle?: string;
  trend?: string;
}> = ({ title, value, icon, subtitle }) => {
  return (
    <div className="card">
      <div style={{ flex: 1 }}>
        <small>{title}</small>
        <strong>{value}</strong>
        {subtitle && (
          <span
            style={{
              fontSize: "11.5px",
              color: "var(--text-muted)",
              marginTop: "6px",
              display: "inline-block",
              fontWeight: 500,
            }}
          >
            {subtitle}
          </span>
        )}
      </div>
      <i className={`fa-solid ${icon}`} />
    </div>
  );
};
